import { userAuthToken } from "../stores/store";
import endpoints from "../functions/databaseEndpoints";

function setAuthToken(data) {
   userAuthToken.set(data);
}

// create user in db
export async function createUserInDB(userData) {
   let status = false;

   const mainEndpoint = `${endpoints.PUBLIC_ENDPOINT}createClient`;
   try {
      const rawResponse = await fetch(mainEndpoint, {
         method: "POST",
         headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
         },
         body: JSON.stringify(userData),
      });
      const content = await rawResponse.json();

      status = content.status;
      setAuthToken(content.data.token);
   } catch (e) {
      console.error(e.message);
   }
   return status;
}
